//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "HAMD",
  data() {
    return {
      form: {
        depressive: "",
        guilty: "",
        idioctonia: "",
        sleepHard: "",
        insomnia:"",
        earlyAwakening:"",
        workAndInterest:"",
        block:"",
        intense:"",
        psychicAnxiety:"",
        somaticAnxiety:"",
        gastrointestinal:"",
        wholeBody:'',
        sexualSymptoms:"",
        hypochondriasis:'',
        loseWeight:"",
        insight:"",
        diurnalMoodVariation:"",
        depersonalization:"",
        paranoidSymptoms:"",
        compulsiveSymptoms:"",
        senseOfDecreasedAbility:"",
        despair:"",
        inferioritComplex:''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "没有" },
        { value: "1", name: "只在问到时才诉述" },
        { value: "2", name: "在访谈中自发地表达" },
        { value: "3", name: "不用言语也可以从表情，姿势，声音或欲哭中流露出这种情绪" },
        { value: "4", name: "自发言语和非语言表达(表情，动作)几乎完全表现为这种情绪" },
      ],
      dataList2: [
        { value: "0", name: "没有" },
        { value: "1", name: "责备自己，感到自己已连累他人" },
        { value: "2", name: "认为自己犯了罪，或反复思考以往的过失和错误" },
        { value: "3", name: "认为目前的疾病是对自己错误的惩罚，或有罪恶妄想" },
        { value: "4", name: "罪恶妄想伴有指责或威胁性幻觉" },
      ],
      dataList3: [
        { value: "0", name: "没有" },
        { value: "1", name: "觉得活着没有意义" },
        { value: "2", name: "希望自己已经死去，或常想与死广有关的事" },
        { value: "3", name: "消极观念(自杀念头)" },
        { value: "4", name: "有严重自杀行为" },
      ],
      dataList4: [
        { value: "0", name: "没有" },
        { value: "1", name: "一入睡困难，上床半小时后仍不能入睡(要注意平时病人入睡的时间)" },
        { value: "2", name: "每晚均有入睡困难" },
      ],
      dataList5: [
        { value: "0", name: "没有" },
        { value: "1", name: "睡眠浅，多噩梦" },
        { value: "2", name: "半夜曾醒来(不包括上厕所)" },
      ],
      dataList6: [
        { value: "0", name: "没有" },
        { value: "1", name: "有早醒，比平时早醒1小时，但能重新入睡，应排除平时习惯" },
        { value: "2", name: "早醒后无法重新入睡" },
      ],
      dataList7: [
        { value: "0", name: "没有" },
        { value: "1", name: "提问时才诉述" },
        { value: "2", name: "主动地表达对工作或学习失去兴趣，如感到没精打彩，需强迫自己去工作或学习" },
        { value: "3", name: "活动或工作时间减少" },
        { value: "4", name: "因目前的疾病而停止工作或学习" },
      ],
      dataList8: [
        { value: "0", name: "没有" },
        { value: "1", name: "轻度阻滞，轻度影响注意力" },
        { value: "2", name: "明显阻滞，明显影响注意力" },
        { value: "3", name: "严重阻滞，严重影响注意力" },
        { value: "4", name: "完全不能回答问题(木僵)" },
      ],
      dataList9: [
        { value: "0", name: "没有" },
        { value: "1", name: "轻度心神不定" },
        { value: "2", name: "明显心神不定，小动作多" },
        { value: "3", name: "严重心神不定，不能静坐" },
        { value: "4", name: "搓手、咬手指、头发、咬嘴唇" },
      ],
      dataList10: [
        { value: "0", name: "没有" },
        { value: "1", name: "问及时诉述" },
        { value: "2", name: "主动地表达出忧虑" },
        { value: "3", name: "表情和语言表现出明显忧虑 " },
        { value: "4", name: "明显惊恐" },
      ],
      dataList11: [
        { value: "0", name: "没有" },
        { value: "1", name: "轻度，不明显" },
        { value: "2", name: "中度，有肯定的上述症状" },
        { value: "3", name: "重度，上述症状严重，影响生活或需要处理 " },
        { value: "4", name: "严重影响生活和活动" },
      ],
      dataList12: [
        { value: "0", name: "没有" },
        { value: "1", name: "食欲减退，不需他人鼓励，可自行进食" },
        { value: "2", name: "进食需他人催促或请求和需要应用泻药或助消化药" },
      ],
      dataList13: [
        { value: "0", name: "没有" },
        { value: "1", name: "四肢，背部或颈部沉重感，背痛、头痛、肌肉疼痛、全身乏力或疲倦" },
        { value: "2", name: "症状明显" },
      ],
      dataList14: [
        { value: "0", name: "没有" },
        { value: "1", name: "轻度" },
        { value: "2", name: "重度" },
        { value: "3", name: "不能肯定" },
      ],
      dataList15: [
        { value: "0", name: "没有" },
        { value: "1", name: "对身体过分关注" },
        { value: "2", name: "反复考虑健康问题" },
        { value: "3", name: "有疑病妄想" },
        { value: "4", name: "伴幻觉的疑病妄想" },
      ],
      dataList16: [
        { value: "0", name: "1周内体重减轻0.5kg以内" },
        { value: "1", name: "1周内体重减轻超过0.5kg" },
        { value: "2", name: "1周内体重减轻超过1kg" },
      ],
      dataList17: [
        { value: "0", name: "知道自己有病，表现为忧郁" },
        { value: "1", name: "知道自己有病，但归咎伙食太差，环境问题，工作过忙，病毒感染或重要休息" },
        { value: "2", name: "完全否认有病" },
      ],
      dataList18: [
        { value: "0", name: "早晚情绪无区别 " },
        { value: "1", name: "早晨或傍晚轻度加重" },
        { value: "2", name: "早晨或傍晚严重加重" },
      ],
      dataList19: [
        { value: "0", name: "没有 " },
        { value: "1", name: "问及时才诉述主动诉述" },
        { value: "2", name: "主动诉述" },
        { value: "3", name: "有虚无妄想(如:觉得自己的身体或世界消失了)" },
        { value: "4", name: "有虚无妄想，并出现幻觉" },
      ],
      dataList20: [
        { value: "0", name: "没有 " },
        { value: "1", name: "有猜疑" },
        { value: "2", name: "有牵连观念(觉得外界事物都与自己有关系)" },
        { value: "3", name: "有牵连观念或被害妄想" },
        { value: "4", name: "有关系妄想或被害妄想，并出现幻觉" },
      ],
      dataList21: [
        { value: "0", name: "没有 " },
        { value: "1", name: "问及时才诉述" },
        { value: "2", name: "主动诉述" },
      ],
      dataList22: [
        { value: "0", name: "没有 " },
        { value: "1", name: "问及时诉述" },
        { value: "2", name: "主动表示有能力减退感" },
        { value: "3", name: "需鼓励，指导和安慰才能完成日常事务或个人卫生" },
        { value: "4", name: "穿衣、梳洗、进食、铺床或个人卫生均需要他人协助" },
      ],
      dataList23: [
        { value: "0", name: "没有 " },
        { value: "1", name: "有时怀疑“情况是否会好转”，但解释后能接受" },
        { value: "2", name: "持续感到“没有希望”，但解释后能接受" },
        { value: "3", name: "对未来感到灰心、悲观和绝望，解释后不能排除" },
        { value: "4", name: "自动反复诉述“未来没有希望”“我的病不会好了”或诸如此类的情况" },
      ],
      dataList24: [
        { value: "0", name: "没有 " },
        { value: "1", name: "仅在询问时诉述有自卑感不如他人" },
        { value: "2", name: "自动诉述有自卑感" },
        { value: "3", name: "主动诉说自己一无是处或低人一等(与评2分者只是程度的差别)" },
        { value: "4", name: "自卑感达妄想的程度，例如“我是废物”或类似情况" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/HAMD.vue